import * as React from "react";
import { Link } from "react-router-dom";
import { TabbedTopbar } from "web-ui";
import type { LinkComponent } from "web-ui/dist/types/components/LinkComponent";

import styles from "components/common/TopbarWithCloseButton.module.scss";

export interface Tab {
  href: string;
  isActive?: boolean;
  name: string;
  onClick?: React.MouseEventHandler;
}
interface Props {
  tabs: Tab[];
}

const component = React.forwardRef<
  HTMLAnchorElement,
  React.AnchorHTMLAttributes<HTMLAnchorElement>
>((props, ref) => <a {...props} ref={ref} />);
component.displayName = "LinkComponent";

const TopbarWithCloseButton = ({ tabs }: Props) => (
  <>
    <TabbedTopbar
      className={styles.tabbedTopbar}
      linkComponent={component as LinkComponent}
      tabs={tabs}
    />
    <Link className={styles.closeButton} title="Go back to home page" to="/">
      ✕
    </Link>
  </>
);

export default TopbarWithCloseButton;
